import { useMemo, useState } from 'react';
import { ISolicitationEntry } from '../../../contentful/types/ISolicitationEntry';
import {
	SOLICITATIONS_ALL_CATEGORIES,
	SOLICITATIONS_ALL_LOCATIONS,
	SOLICITATIONS_ALL_STATUSES,
	SOLICITATIONS_ALL_TYPES,
} from '../domain/models/SolicitationsFilterOption';

export function useSolicitationsStore(solicitations: ISolicitationEntry[]) {
	const [type, setType] = useState<string>();
	const [category, setCategory] = useState<string>();
	const [location, setLocation] = useState<string[]>();
	const [status, setStatus] = useState<string>();

	const filteredData = useMemo(() => {
		let filteredSolicitations = solicitations;

		if (type && type !== SOLICITATIONS_ALL_TYPES) {
			filteredSolicitations = filteredSolicitations.filter(
				(solicitation) => solicitation.fields.type === type,
			);
		}

		if (category && category !== SOLICITATIONS_ALL_CATEGORIES) {
			filteredSolicitations = filteredSolicitations.filter(
				(solicitation) => solicitation.fields.category === category,
			);
		}

		if (location && location[0] !== SOLICITATIONS_ALL_LOCATIONS) {
			filteredSolicitations = filteredSolicitations.filter((solicitation) =>
				solicitation.fields.location?.some((solicitationLocation) =>
					location.includes(solicitationLocation),
				),
			);
		}

		if (status && status !== SOLICITATIONS_ALL_STATUSES) {
			filteredSolicitations = filteredSolicitations.filter(
				(solicitation) => solicitation.fields.status === status,
			);
		}

		return filteredSolicitations;
	}, [type, category, location, status, solicitations]);

	return {
		filteredData,
		setType,
		setCategory,
		setLocation,
		setStatus,
	};
}
